import axios from "axios";
import Errores from "../utils/Errores.js";

//tokens para cancelar llamadas
let CancelToken = axios.CancelToken;
let cancel;

//consulta por minifichas de establecimientos segun filtros y condiciones de busqueda
let getEstablecimientos = async function(
  comuna,
  dependencia,
  etiquetaNivel,
  generos,
  jornadas,
  nombre,
  otros,
  programa,
  orden,
  componente
) {
  let url = API.VITRINA + "v1/establecimientos";
  //agregar comuna
  url = url + "?comuna=" + comuna;
  //agregar dependencia
  dependencia
    ? dependencia.filtros.forEach(d => {
        url = url + "&dependencia=" + d;
      })
    : null;
  //agregar etiqueta nivel
  etiquetaNivel !== "" ? (url = url + "&etiquetaNivel=" + etiquetaNivel) : null;
  //agregar generos
  generos
    ? generos.filtros.forEach(g => {
        url = url + "&genero=" + g;
      })
    : null;
  //agregar jornadas
  jornadas
    ? jornadas.filtros.forEach(j => {
        url = url + "&jornadas=" + j;
      })
    : null;
  //agregar nombre
  nombre !== "" ? (url = url + "&nombre=" + nombre) : null;
  //agregar otros
  otros
    ? otros.filtros.forEach(o => {
        url = url + "&otrosCriterios=" + o;
      })
    : null;

  if (programa && programa.filtros && programa.filtros.length > 0) {
    url += "&programa=" + encodeURIComponent(programa.filtros[0]);
  }
  orden !== "" ? (url = url + "&orden=" + orden) : null;

  let resultado = await axios
    .get(url)
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      Errores.switchErrors(error, componente);
      return null;
    });
  return resultado;
};

//consulta datos de ficha establecimiento por rbd
let getFichaEstablecimiento = async function(rbd, componente) {
  let url = API.VITRINA + "v1/establecimientos/" + rbd;

  let resultado = await axios
    .get(url)
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      Errores.switchErrors(error, componente);
      return null;
    });
  return resultado;
};

export default {
  getEstablecimientos,
  getFichaEstablecimiento
};



// WEBPACK FOOTER //
// ./src/services/ApiEstablecimientos.js